import * as yup from 'yup';
import utils from 'shared/helpers/utils';
import { FORM_KEYS, GLOBAL, NO_OF_CHARS } from 'shared/constant';
import arrOptions from 'shared/constant/arrOptions';

const { occupationNA } = arrOptions;
const { ASI } = FORM_KEYS;
const { CLIENT_MIN_AGE } = GLOBAL;
const LEGAL_GUARDIAN = 'legalGuardian';
const { translateAnswer } = utils;

/**
 * Page or section validation
 * this displays all error messages when page is submitted
 * @param {*} intl
 * @param {*} isPOAholder
 * @param {*} clientAge
 */
export const asiPageSchema = (intl, isPOAholder, clientAge, authorityToDeal, poaOccupation) => yup.object().shape({
  [ASI.POA_HOLDER]: yup
    .string()
    .nullable()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && clientAge > CLIENT_MIN_AGE) return false;
        return true;
      },
    ),
  [ASI.IS_AUTHORITY_TO_DEAL]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && clientAge < CLIENT_MIN_AGE) return false;
        return true;
      },
    ),
  [ASI.NAME]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  [ASI.DOB]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.dob' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.dob' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  [ASI.ADDRESS]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.address' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.address' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  // .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
  // .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
  [ASI.EMAIL_ADDRESS]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.email' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.email' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  // .email(intl.formatMessage({ id: 'validation.invalidEmailFormat' })),
  [ASI.NATIONALITY]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.nationality' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.nationality' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  [ASI.OCCUPATION]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.occupation' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.occupation' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
  // .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
  [ASI.POSITION]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.position' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.position' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) {
          if (occupationNA.includes(poaOccupation)) return true;
          return false;
        }
        return true;
      },
    ),
  // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
  // .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
  [ASI.MOBILE]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.mobile' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.mobile' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  [ASI.EMPLOYER_BUSINESS_NAME]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.employer' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.employer' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) {
          if (occupationNA.includes(poaOccupation)) return true;
          return false;
        }
        return true;
      },
    ),
  // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
  // .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
  [ASI.RELATIONSHIP_WITH_CLIENT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.relationshipWithClient' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.relationshipWithClient' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
  // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
  // .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
  [ASI.IS_AS_US_PERSON]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.isAuthorized' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.isAuthorized' }) }),
      (value) => {
        if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
        return true;
      },
    ),
});

/**
 * Single Field Validation
 * this is to validation each field when input is touched
 * @param {*} intl
 * @param {*} elementName
 * @param {*} clientAge
 * @param {*} isPOAholder
 */
export const asiFieldsSchema = (intl, elementName, clientAge, isPOAholder, authorityToDeal, poaOccupation) => {
  switch (elementName) {
    case ASI.POA_HOLDER:
      return yup.object().shape({
        [ASI.POA_HOLDER]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              // if (!value && (isPOAholder === intl.formatMessage({ id: 'yes' }) || clientAge <= CLIENT_MIN_AGE)) return false;
              if (!value && clientAge > CLIENT_MIN_AGE) return false;
              return true;
            },
          ),
      });
    case ASI.IS_AUTHORITY_TO_DEAL:
      return yup.object().shape({
        [ASI.IS_AUTHORITY_TO_DEAL]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && clientAge < CLIENT_MIN_AGE) return false;
              return true;
            },
          ),
      });
    case ASI.NAME:
      return yup.object().shape({
        [ASI.NAME]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.name' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.name' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case ASI.DOB:
      return yup.object().shape({
        [ASI.DOB]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.dob' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.dob' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          ),
      });
    case ASI.ADDRESS:
      return yup.object().shape({
        [ASI.ADDRESS]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.address' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.address' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    case ASI.EMAIL_ADDRESS:
      return yup.object().shape({
        [ASI.EMAIL_ADDRESS]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.email' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.email' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          )
          .email(intl.formatMessage({ id: 'validation.invalidEmailFormat' })),
      });
    case ASI.NATIONALITY:
      return yup.object().shape({
        [ASI.NATIONALITY]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.nationality' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.nationality' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          ),
      });
    case ASI.OCCUPATION:
      return yup.object().shape({
        [ASI.OCCUPATION]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.occupation' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.occupation' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case ASI.POSITION:
      return yup.object().shape({
        [ASI.POSITION]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.position' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.position' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) {
                if (occupationNA.includes(poaOccupation)) return true;
                return false;
              }
              return true;
            },
          )
          // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case ASI.MOBILE:
      // const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;
      return yup.object().shape({
        [ASI.MOBILE]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.mobile' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.mobile' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN_MOBILE, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN_MOBILE })),
          // .matches(phoneRegExp, intl.formatMessage({ id: 'validation.invalidMobileFormat' })),
      });
    case ASI.EMPLOYER_BUSINESS_NAME:
      return yup.object().shape({
        [ASI.EMPLOYER_BUSINESS_NAME]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.employer' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.employer' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) {
                if (occupationNA.includes(poaOccupation)) return true;
                return false;
              }
              return true;
            },
          )
          // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case ASI.RELATIONSHIP_WITH_CLIENT:
      return yup.object().shape({
        [ASI.RELATIONSHIP_WITH_CLIENT]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.relationshipWithClient' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'asi.relationshipWithClient' }) }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case ASI.IS_AS_US_PERSON:
      return yup.object().shape({
        [ASI.IS_AS_US_PERSON]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && (translateAnswer(isPOAholder, intl) === intl.formatMessage({ id: 'yes' }) || authorityToDeal === LEGAL_GUARDIAN)) return false;
              return true;
            },
          ),
      });
    default:
  }
};
